import { ButtonWithIcon, Button } from '@/components/atoms'
import { COLOR } from '@/utils/constants/colors'
import { SIZE } from '@/utils/constants/globalStyle'
import { Font } from 'pepsico-ds'
import { useFormContext } from "react-hook-form"
import { Dropdown } from "@/components/atoms"
import { TextInputField } from '@/components/molecules'
import { useIntl } from 'react-intl'
import { useState, useEffect } from 'react'

const Item = ({ data, handleChange, handleDelete, index, activityOptions }) => {
  const { formatMessage } = useIntl()
  const handleActivity = (value) => {
    const selectedActivity = value[0];
    if (selectedActivity) {
      handleChange(index, {
        ...data,
        activityID: selectedActivity.id,
        activityName: selectedActivity.displayText || selectedActivity.name
      })
    }
  }

  const handleMultiplier = (value) => {
    if (value) {
      const multiplier = parseFloat(value)
      handleChange(index, {
        ...data,
        multiplier: multiplier
      })
    }
  }

  return (
    <div className="flex w-full items-center h-12" data-testid="item">
      <div className='flex items-start gap-4'>
        <Dropdown
          placeholder={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_PLACEHOLDER' })}
          isDark
          childList={activityOptions}
          value={[{ id: data?.activityID || '', displayText: data?.activityName || '' }]}
          updateValue={handleActivity}
          isJsonWrap={false}
        />
        <TextInputField
          isDark
          value={data?.multiplier}
          updateValue={handleMultiplier}
          visible
          schema={{
            type: 'number',
            restrictDecimal: false
          }}
          uiSchema={{
            placeholder: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TEXT_PLACEHOLDER' }),
            isDark: true,
          }}
        />
      </div>
      {index > 0 ? (
        <Button
          handleButton={() => handleDelete(index)}
          uiSchema={{
            className: 'ml-4',
            title: 'Delete',
            variant: 'tertiary',
            size: 'medium',
          }}
          style={{ marginLeft: '-50%', marginBottom: '.5rem', zIndex: '10' }}
        />
      ) : null}
    </div>
  )
}

export const ActivitiesSelector = ({ activities = [] }) => {
  const { formatMessage } = useIntl()
  const { setValue, getValues } = useFormContext();
  const formActivitiesFromForm = getValues('activities') || [];
  const [localActivities, setLocalActivities] = useState(formActivitiesFromForm);

  useEffect(() => {
    setLocalActivities(getValues('activities') || []);
  }, [getValues]);

  const activityOptions = activities.length > 0
    ? activities.map(activity => ({
        id: activity.id,
        displayText: activity.name,
      }))
    : [];

  const handleChange = (index, newValue) => {
    const updatedActivities = [...localActivities];
    updatedActivities[index] = newValue;

    setValue(`activities.${index}`, newValue);
    setLocalActivities(updatedActivities);
  }

  const handleDelete = index => {
    const nextActivities = localActivities.filter((_, currentIndex) => currentIndex !== index);
    setValue('activities', nextActivities);
    setLocalActivities(nextActivities);
  }

  const createNewActivity = () => {
    const newActivity = {
      activityID: '',
      activityName: '',
      multiplier: 0
    };

    const nextActivities = [...localActivities, newActivity];

    setValue('activities', nextActivities);
    setLocalActivities(nextActivities);
  }

  return (
    <>
      <Font variant="bold" size="body" textColorClass="text-white" className="mb-5">
        {formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ACTIVITIES_TITLE' })}
      </Font>
      {localActivities.map((activity, index) => (
        <Item
          data={activity}
          handleChange={handleChange}
          handleDelete={handleDelete}
          key={index}
          index={index}
          activityOptions={activityOptions}
        />
      ))}
      <ButtonWithIcon
        uiSchema={{
          className: 'flex items-center text-[#0069D7] border-none',
          title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_ADD_ACTIVITY' }),
          size: SIZE.SMALL,
          variant: COLOR.TERTIARY,
          isDark: true,
        }}
        iconLeading="add_box"
        handleButton={createNewActivity}
      />
    </>
  )
}
